import React from 'react';
import AccordionSimple from 'components/accordion/AccordionSimple';
import { FAQComingSoon } from "constants/faq";

function FAQs({ data}) {
  return (
    <section
        className="section about container"
        data-aos="fade-up"
        data-aos-delay="200"
      >
        <div className="d-flex mb-md-5 py-md-4 justify-content-center align-text-center">
          <h1 id="faq-title" className="heading">Frequently Asked Questions</h1>
        </div>
        <div className="col-xl-10 mx-auto">
          <AccordionSimple
            data={data?.faqData}
            toggleButton={true}
            viewAllButton={data?.faqData?.length > 8}
          />
        </div>
      </section>
  )
}

export default FAQs